import { Component, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { applicationList, deviceList, getAnalyticsData, getApplications, getDevices, getSensors, orgList } from 'src/app/shared/models/data-visuals';
import { DataVisualsService } from 'src/app/shared/services/data-visuals.service';


@Component({
  selector: 'app-data-visuals',
  templateUrl: './data-visuals.component.html',
  styleUrls: ['./data-visuals.component.scss']
})
export class DataVisualsComponent implements OnInit {
  user: any;
  userName: string = '';
  sensorsValue: any[] = [];
  bindValuesInChart: any[] = [];
  myForm: FormGroup;
  isLoading: boolean = false;

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};

  filterBydate: any = [
    { display: "Last 30 Minutes", value: "last_30_minutes" },
    { display: "Last 1 Hour", value: "last_1_hour" },
    { display: "Today", value: "today" },
    { display: "Yesterday", value: "yesterday" }
  ]

  appName: string;
  showTitle: boolean = false;
  landingContent: boolean = true;
  orgList: orgList[];
  orgName: string;
  deviceList: deviceList[];
  deviceName: string;
  applicationsList: applicationList[];
  applicationName: string;
  sensorsList: any[];
  noData: boolean = false;
  date: string;
  showSensorsCheckboxes: boolean = false;
  setDefaultDevice: boolean = false;
  displayApplicationName: string;
  organizationName: string;
  noSensorsFound: boolean;
  selectedSensors: string[];
  api_key: string;
  client_id: string;

  constructor(
    private dataVisualsService: DataVisualsService,
    private toasterService: ToastrService,
    private formBuilder: FormBuilder

  ) {
    this.user = sessionStorage.getItem('user');
    if (this.user) {
      this.userName = JSON.parse(this.user).username;
    }
  }

  async ngOnInit() {
    this.getOrganizations();
    this.myForm = this.formBuilder.group({
      org: ['', Validators.required],
      device: ['', Validators.required],
      applications: ['', Validators.required]
    })
  }

  onChangeOrg(event: any) {
    if (event.target.value !== "") {
      this.orgName = event.target.value;
      this.getDevicesByOrg();
      this.getApplicationsByOrg();
    }
  }

  onChangeDevice(event: any) {
    if (event.target.value != "") {
      this.deviceName = event.target.value;
      // this.getApplicationsByOrg();
    }
  }

  onChangeApplications(event: any) {
    if (event.target.value != "") {
      this.applicationName = event.target.value;
      // this.getSensorsByApplications();
      // this.showSensorsCheckboxes = true;
    }
  }

  onChangeDate(event: any) {
    this.date = event.target.value;
  }

  async getOrganizations() {
    this.isLoading = true;
    try {
      const result = await this.dataVisualsService.getOrganizations().toPromise();
      if (result) {
        this.orgList = result.data;
        this.isLoading = false;
      }
    } catch (err: any) {
      console.log(err.error.message);
      this.isLoading = false;
    }
  }

  async getDevicesByOrg() {
    this.isLoading = true;

    const dropdown = document.getElementById('organizationDropdown') as HTMLSelectElement;

    const payload: getDevices = {
      organizationId: dropdown.options[dropdown.selectedIndex].text
    };

    try {
      const result: any = await this.dataVisualsService.getDevices(payload).toPromise();
      if (result) {
        this.deviceList = result.data;
        // if (this.deviceList.length === 1) {
        //   const singleDevice = this.deviceList[0];
        //   this.bindDevice = singleDevice;
        //   this.setDefaultDevice = true;

        // this.deviceName = singleDevice.thing_name;
        // this.myForm.get('device')?.setValue(this.deviceName);

        // this.getApplicationsByDevice();
        // }
      }
      this.isLoading = false;
    } catch (err: any) {
      console.error(err.error.message);
      this.toasterService.error(err.error.message);
      this.isLoading = false;
    }
  }


  async getApplicationsByOrg() {
    this.isLoading = true;
    const dropdown = document.getElementById('organizationDropdown') as HTMLSelectElement;
    this.organizationName = dropdown.options[dropdown.selectedIndex].text;

    const payload: getApplications = {
      // organizationName: this.organizationName
      organizationId: this.organizationName
    };

    try {
      const result: any = await this.dataVisualsService.getApplications(payload).toPromise();
      if (result) {
        this.applicationsList = result.data;
        // if (this.applicationsList.length === 1) {
        //   const singleApplication = this.applicationsList[0];
        //   this.bindApplication = singleApplication;
        //   this.setDefaultApplication = true;

        //   this.applicationName = singleApplication.application_identifier;
        //   this.myForm.get('applications')?.setValue(this.applicationName);
        // }
      }
      this.isLoading = false;
    } catch (err: any) {
      console.error(err.error.message);
      this.toasterService.error(err.error.message);
      this.isLoading = false;
    }
  }

  async getSensorsByApplications() {
    this.isLoading = true;

    const payload: getSensors = {
      applicationId: this.applicationName
    }
    try {
      const result: any = await this.dataVisualsService.getSensors(payload).toPromise();
      if (result.data.length == 0) {
        this.toasterService.warning("No sensors were detected!")
        this.isLoading = false;
        this.showSensorsCheckboxes = false;
        this.landingContent = false;
        this.noSensorsFound = true;
      } else {
        this.sensorsList = result.data[0].sensors.map((sensor: string) => {
          return sensor;
        });
        this.showSensorsCheckboxes = true;
        this.isLoading = false;
      }
    } catch (err: any) {
      console.log(err.error.message);
      this.toasterService.error(err.error.message);
      this.isLoading = false;
    }
  }

  async onSubmit() {
    if (this.myForm.invalid) {
      this.myForm.markAllAsTouched();
      this.toasterService.error("Kindly select the mandatory fields.");
      return;
    }
    this.appName = this.applicationName;
    this.landingContent = false;
    this.isLoading = true;

    try {
      const orgId = this.myForm.get('org').value;
      const orgDetailsResult: any = await this.dataVisualsService.getOrganizationDetails(orgId).toPromise();
      if (orgDetailsResult.success) {
        const result = orgDetailsResult.data;
        this.api_key = result.api_key;
        this.client_id = result.client_id;
        await this.getAllAnalytics();
        this.isLoading = false;
      }
    } catch (err: any) {
      console.log(err.error.message);
      this.toasterService.error(err.error.message);
      this.isLoading = false;
    }
    this.isLoading = false;
  }


  async getAllAnalytics() {
    this.isLoading = true;
    this.landingContent = false;

    const payload: getAnalyticsData = {
      device_id: this.deviceName,
      userName: this.userName,
      application_id: this.applicationName,
      // sensors: null,
      date: this.date ? this.date : 'last_7_days',
    };

    try {
    const result: any = await this.dataVisualsService.getAllAnalyticsData(payload, this.api_key, this.client_id).toPromise();
    if (result?.success) {
    if (result.Data.length > 0) {
    this.showTitle = true;

    this.sensorsValue = result.Data;
    this.noData = false;

    const newSensorsList = Object.keys(result.Data[0].sensorValues);
    this.showSensorsCheckboxes = true;

    const previouslySelected = new Set(this.selectedSensors || []);

    this.selectedSensors = previouslySelected.size > 0
      ? newSensorsList.filter(sensor => previouslySelected.has(sensor))
      : [...newSensorsList];

    this.sensorsList = newSensorsList;

    // const selectedSensors = this.sensorsList.filter((sensor: any) => {
    //   const checkbox = document.getElementById(`sensor-checkbox-${sensor}`) as HTMLInputElement;
    //   return checkbox?.checked;
    // });

    const chartsContainer = document.getElementById('charts-container');
    if (chartsContainer) {
      Array.from(chartsContainer.children).forEach((child) => {
        child.remove();
      });
    }

    newSensorsList.forEach((sensorKey: any) => {
      const chartData: any = {};
      this.sensorsValue.forEach((item: any) => {
        const utcDate = new Date(item.utcDateTime);
        const istDate = new Date(utcDate.getTime() + 5.5 * 60 * 60 * 1000);

        Object.keys(item.sensorValues).forEach((key) => {
          if (!chartData[key]) chartData[key] = [];
          chartData[key].push({
            x: istDate.getTime(),
            y: item.sensorValues[key],
            message: item.message,
            dateTime: istDate.toLocaleString(),
          });
        });
      });

      const containerId = `chart-container-${sensorKey}`;
      let chartContainer = document.getElementById(containerId);

      if (!chartContainer) {
        const wrapperDiv = document.createElement('div');
        wrapperDiv.id = containerId;
        wrapperDiv.className = 'chart-wrapper';
        wrapperDiv.style.position = 'relative';
        wrapperDiv.style.margin = '10px 0';
        wrapperDiv.style.border = '1px solid #ccc';
        wrapperDiv.style.borderRadius = '20px';
        wrapperDiv.style.backgroundColor = '#fff';
        wrapperDiv.style.padding = '10px';
        wrapperDiv.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.2)';

        if (this.selectedSensors.length !== 1) {
          const closeButton = document.createElement('button');
          closeButton.innerHTML = 'X';
          closeButton.className = 'close-chart-button';
          closeButton.style.position = 'absolute';
          closeButton.style.top = '15px';
          closeButton.style.right = '15px';
          closeButton.style.backgroundColor = '#01395e';
          closeButton.style.color = '#fff';
          closeButton.style.border = 'none';
          closeButton.style.borderRadius = '50%';
          closeButton.style.width = '25px';
          closeButton.style.height = '25px';
          closeButton.style.cursor = 'pointer';
          closeButton.style.zIndex = '10';

          closeButton.addEventListener('click', () => {
            wrapperDiv.remove();
            const remainingCharts = chartsContainer.querySelectorAll('.chart-wrapper');
            if (remainingCharts.length === 1) {
              // this.landingContent = true;
              // this.showTitle = false;
              const lastChart = remainingCharts[0];
              console.log(lastChart);
              const lastCloseButton = lastChart.querySelector('.close-chart-button');
              console.log(lastCloseButton);
              if (lastCloseButton) {
                lastCloseButton.remove();
              }
            }
          });

          wrapperDiv.appendChild(closeButton);
        }


        const chartDiv = document.createElement('div');
        chartDiv.style.width = '100%';
        chartDiv.style.height = '400px';
        wrapperDiv.appendChild(chartDiv);

        chartsContainer.appendChild(wrapperDiv);

        const allPoints = Object.values(chartData as Record<string, any[]>).reduce(
          (acc: any[], arr: any[]) => acc.concat(arr),
          []
        );

        const minTime = Math.min(...allPoints.map((point: any) => point.x));
        const maxTime = Math.max(...allPoints.map((point: any) => point.x));

        Highcharts.chart(chartDiv, {
          chart: {
            type: 'line',
          },
          title: {
            text: `${sensorKey.replace('_', ' ')} Data`,
          },
          xAxis: {
            type: 'datetime',
            title: {
              text: 'Timestamp',
            },
            min: minTime,
            max: maxTime,
            labels: {
              formatter: function () {
                const istTime = this.value + 5.5 * 60 * 60 * 1000; // Add 5:30 to UTC
                return Highcharts.dateFormat('%d-%m-%Y %H:%M', istTime);
              },
            },
          },

          yAxis: {
            title: {
              text: `${sensorKey.replace('_', ' ')} Value`,
            },
          },
          tooltip: {
            formatter: function () {
              const message = this.point.message
                ? `<br><b>Message:</b> ${this.point.message}`
                : '';
              const dateTime = this.point.dateTime; // IST datetime
              return `<b>${this.series.name}</b><br><b>Time:</b> ${dateTime}<br><b>Value:</b> ${this.y}${message}`;
            },
          },
          legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'bottom',
          },
          series: Object.keys(chartData).map((key) => ({
            name: key.replace('_', ' '),
            data: chartData[key],
            type: 'line',
            visible: key === sensorKey,
          })),
        });
      }
    });
    const dropdown = document.getElementById('applicationDropdown') as HTMLSelectElement;
    this.displayApplicationName = dropdown.options[dropdown.selectedIndex].text.toLocaleUpperCase();
    } 
    else {
      this.noData = true;
      this.showTitle = false;
      this.toasterService.warning('No sensor values were found!');
      const chartsContainer = document.getElementById('charts-container');
      if (chartsContainer) {
        chartsContainer.innerHTML = '';
      }
    }
    }
    this.isLoading = false;
    } 
    catch (error) {
      console.error("Error fetching analytics data:", error);
      this.isLoading = false;
    }


  }
}

declare module 'highcharts' {
  interface Point {
    message?: string;
    dateTime?: string
  }
}
